import { ScriptDef, ScriptTheme } from '../../types';

export const MOVIE_DADAO_SCRIPTS: ScriptDef[] = [
    {
        id: 'SCRIPT_110',
        name: '水磨调',
        genre: 'movie',
        synopsis: '昆曲冠生谢照君人到中年，剧团改制，老戏接连摘牌。他收了个野路子出身的女孩盛念枝做徒弟，把一出几十年没人敢碰的家传老戏一折一折拆给她学。师徒二人从互不服气到互相成全，老戏重新立上舞台，两代人各自的心事，也跟着水磨腔一句一句摆上了台面。',
        roles: [
            {
                name: '盛念枝',
                roleType: '女主角',
                billing: 1,
                intro: '野路子出身的戏曲学院旁听生，嗓子条件出众，基本功一塌糊涂。拜师那天磕了三个头，起身就忘了程式。',
                level: 9,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 100 },
                    { attr: 'artistry', value: 90 },
                    { attr: 'charm', value: 80 },
                    { attr: 'temperament', value: 70 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 5, artistry: 4, charm: 4, temperament: 3 },
            },
            {
                name: '唐弦',
                roleType: '女配角',
                billing: 3,
                intro: '曲师，给谢照君笛子伴奏多年。老戏的工尺谱是她父亲留下的，一个字没敢改。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'artistry', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, artistry: 3, temperament: 2, wisdom: 2 },
            },
            {
                name: '裴望',
                roleType: '男配角',
                billing: 3,
                intro: '剧团的年轻笛师，唐弦的师弟。老戏复排的工尺谱，是他一笔一笔誊清的，誊到"哭头"那一段停了三次。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'artistry', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, artistry: 3, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Culture, ScriptTheme.Performance, ScriptTheme.Music],
        heat: 50,
        baseScore: 9.3,
    },
    {
        id: 'SCRIPT_111',
        name: '深空回声',
        genre: 'movie',
        synopsis: '人类首艘核动力深空科考船"夸父号"在木星轨道失联，地面联合指挥中心展开营救。中方总工程师沈牧遥必须在燃料极限与三百名船员之间做取舍，唯一的备用方案，是让全员冬眠、飞船漂行十年等待回收窗口。船上最年轻的领航员林疏桐受命执行冬眠序列，地面等到的第一条回声，来自她。',
        roles: [
            {
                name: '林疏桐',
                roleType: '女主角',
                billing: 2,
                intro: '船上最年轻的领航员，受命执行冬眠序列。她发出的反馈信号，是失联后地面收到的第一条回声。',
                level: 9,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 100 },
                    { attr: 'temperament', value: 90 },
                    { attr: 'wisdom', value: 80 },
                    { attr: 'charm', value: 70 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 5, temperament: 4, wisdom: 4, charm: 3 },
            },
            {
                name: '苏眠',
                roleType: '女配角',
                billing: 3,
                intro: '地面指挥中心的轨道计算员，林疏桐的同学。冬眠序列的回收窗口是她算的，算完在屏幕上盯了很久。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'wisdom', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 4, wisdom: 3, temperament: 3, charm: 3 },
            },
            {
                name: '周砚',
                roleType: '男配角',
                billing: 3,
                intro: '夸父号随船医官，负责冬眠舱的生命监测。他签了全船三百份冬眠同意书，唯独自己那份空着。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'stamina', value: 50 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, wisdom: 3, stamina: 2, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Disaster, ScriptTheme.SeriousDrama],
        heat: 56,
        baseScore: 9.0,
    },
    {
        id: 'SCRIPT_112',
        name: '宝船',
        genre: 'movie',
        synopsis: '明永乐年间，宝船船队第四次下西洋。年轻通译官方觉岸在船队里认出了失踪多年的兄长方觉沧——他是私逃出海的匠人，藏在粮舱里，船队过风暴洋面的水密改法出自他手。兄长的手艺关系着全船的安危，弟弟的身份又瞒不住随船监军。风暴与追查同时到来，兄弟俩一个要还家，一个要还海。',
        roles: [
            {
                name: '方觉岸',
                roleType: '男主角',
                billing: 1,
                intro: '船队通译官，通番语，少年中选。在粮舱里认出兄长那天，他的差事和亲情头一次打架。',
                level: 9,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 100 },
                    { attr: 'temperament', value: 90 },
                    { attr: 'wisdom', value: 80 },
                    { attr: 'charm', value: 70 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 5, temperament: 4, wisdom: 4, charm: 3 },
            },
            {
                name: '方觉沧',
                roleType: '男二号',
                billing: 2,
                intro: '私逃出海的匠人，水密隔舱的改法出自他手。上船不为钱，为的是船队要去的那个风口浪尖。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'wisdom', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 4, wisdom: 3, temperament: 3, stamina: 3 },
            },
            {
                name: '闻采薇',
                roleType: '女配角',
                billing: 3,
                intro: '随船女史官，掌船队航海日志。风暴夜她记下旗舰改向的每一个刻度，也认出了粮舱里那套水密改法的旧针脚。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 60 },
                    { attr: 'wisdom', value: 55 },
                    { attr: 'talent', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, wisdom: 3, talent: 2, charm: 2 },
            },
            {
                name: '凌波',
                roleType: '女配角',
                billing: 4,
                intro: '宝船上的通事女官，通三门外语。风暴夜她替方觉岸传了最后一道旗语，旗语里的暗号是她自己加的。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 50 },
                    { attr: 'talent', value: 45 },
                    { attr: 'stamina', value: 40 },
                ],
                shootWeeks: 2,
                attributeGrowth: { temperament: 3, talent: 3, stamina: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.History, ScriptTheme.Ancient, ScriptTheme.SeriousDrama],
        heat: 51,
        baseScore: 8.5,
    },
    {
        id: 'SCRIPT_113',
        name: '寰宇纪元',
        genre: 'movie',
        synopsis: '资源枯竭的地球启动"寰宇计划"，第一代开拓者率舰队驶离母星，第二代人留守中继站为后代维持航路信号，第三代人在飞船上出生、从未见过任何星球。三代主角互不相识，三条故事线各自推进，最终以一场共同的梦境收拢。',
        roles: [
            {
                name: '贺遥',
                roleType: '女主角',
                billing: 1,
                intro: '第一代开拓舰的领航员，寰宇计划的发起者之一，在舰队驶离地球时做出最终出发决定。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, charm: 3 },
            },
            {
                name: '雷长风',
                roleType: '男二号',
                billing: 3,
                intro: '第二代故事线的舰队大副，负责向新船员介绍舰上事务。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2 },
            },
            {
                name: '陈致宇',
                roleType: '男配角',
                billing: 4,
                intro: '第三代故事线中的随船学员，自幼在飞船上长大，从未踏足任何星球。',
                level: 6,
                gender: 'male',
                requirements: [
                    { attr: 'charm', value: 50 },
                    { attr: 'temperament', value: 45 },
                    { attr: 'talent', value: 40 },
                ],
                shootWeeks: 2,
                attributeGrowth: { charm: 3, temperament: 3, talent: 2 },
            },
            {
                name: '江月初',
                roleType: '女配角',
                billing: 4,
                intro: '中继站的第三代通讯官，在飞船上出生。她给从未见过的地球写过四百封没寄出的信。',
                level: 6,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 50 },
                    { attr: 'wisdom', value: 45 },
                    { attr: 'temperament', value: 40 },
                ],
                shootWeeks: 2,
                attributeGrowth: { talent: 3, wisdom: 3, temperament: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.Action, ScriptTheme.SeriousDrama],
        heat: 27,
        baseScore: 4.3,
    },
    {
        id: 'SCRIPT_114',
        name: '拉格朗日',
        genre: 'movie',
        synopsis: '地月拉格朗日点的空间站扩建工程启动，中方结构工程师顾星阑成为最年轻的首席驻站。俄方舱段总师、印度裔推进专家与她同班组共事，三家的方案互不相让。扩建进度与运载窗口同时逼近，三位女工程师把方案摆上同一张工位桌，用一场联合计算让所有质疑收了声。',
        roles: [
            {
                name: '顾星阑',
                roleType: '女主角',
                billing: 1,
                intro: '中方结构工程师，空间站扩建最年轻的首席。方案被质疑时，她加班算出了新版本。',
                level: 9,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 100 },
                    { attr: 'wisdom', value: 90 },
                    { attr: 'temperament', value: 80 },
                    { attr: 'charm', value: 70 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 5, wisdom: 4, temperament: 4, charm: 3 },
            },
            {
                name: '沈砚冰',
                roleType: '女配角',
                billing: 3,
                intro: '空间站的中方材料工程师，顾星阑的副手。三家的对接件都是她验的，验出过俄方舱段一处肉眼看不见的应力纹。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'wisdom', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 4, wisdom: 3, temperament: 3, charm: 3 },
            },
            {
                name: '秦岳',
                roleType: '男配角',
                billing: 3,
                intro: '空间站的驻站机械师，负责舱外作业。联合计算那晚，他把自己那台机器的数据全导给了顾星阑。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'stamina', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, stamina: 3, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.SciFi, ScriptTheme.SeriousDrama, ScriptTheme.Female],
        heat: 56,
        baseScore: 8.8,
    },
    {
        id: 'SCRIPT_115',
        name: '听证',
        genre: 'movie',
        synopsis: '南太平洋深海采矿事故，十二人作业组只有中方潜水长池婉生还。跨国公司的律师团指她的操作违规，她带着潜水日志和一只失聪的左耳出席国际听证。庭上每一份证据都有两个版本，唯一的真相沉在两千米的海底。池婉拒绝纸面作证，申请重返事故海域，把证词打捞上来。',
        roles: [
            {
                name: '池婉',
                roleType: '女主角',
                billing: 1,
                intro: '中方饱和潜水长，事故唯一幸存者，左耳失聪。她拒绝纸面作证，要求重返海底当庭陈述。',
                level: 9,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 100 },
                    { attr: 'temperament', value: 90 },
                    { attr: 'wisdom', value: 80 },
                    { attr: 'stamina', value: 70 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 5, temperament: 4, wisdom: 4, stamina: 3 },
            },
            {
                name: '程叙白',
                roleType: '女二号',
                billing: 2,
                intro: '中方委托的国际海事律师，头一次替潜水员出庭。她把池婉的潜水日志逐条译成了证据。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'wisdom', value: 70 },
                    { attr: 'temperament', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 4, wisdom: 3, temperament: 3, charm: 3 },
            },
            {
                name: '宋屿',
                roleType: '男配角',
                billing: 3,
                intro: '中方海事局的事故调查员，听证庭的中方席位。池婉的潜水日志他逐页比对过，发现了一处被人改动过的压力值。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Disaster, ScriptTheme.SeriousDrama, ScriptTheme.Female],
        heat: 52,
        baseScore: 8.6,
    },
    {
        id: 'SCRIPT_116',
        name: '衔石记',
        genre: 'movie',
        synopsis: '炎帝的小女儿女娃溺亡东海，化作了精卫。所有人都说衔石填海是复仇，只有她自己知道，海里还有太多回不了家的亡魂，她填的是一条回家的路。海的主宰沧溟掀起巨浪拦她，浪打得越高，她衔来的石子铺得越长。',
        roles: [
            {
                name: '精卫',
                roleType: '女主角',
                billing: 1,
                intro: '炎帝的小女儿女娃，溺亡东海后化为鸟。她填海不为报仇，为的是给回不了家的亡魂修一条路。',
                level: 9,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 100 },
                    { attr: 'temperament', value: 90 },
                    { attr: 'charm', value: 80 },
                    { attr: 'wisdom', value: 70 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 5, temperament: 4, charm: 4, wisdom: 3 },
            },
            {
                name: '沧溟',
                roleType: '女二号',
                billing: 2,
                intro: '海的化身，掌管海里所有亡魂的名字。她一路阻拦精卫，最后默许浪退开了一条路。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 80 },
                    { attr: 'talent', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 4,
                attributeGrowth: { temperament: 4, talent: 3, wisdom: 3, charm: 3 },
            },
            {
                name: '炎帝',
                roleType: '男配角',
                billing: 2,
                intro: '小女儿的父亲，部落的首领。所有人都劝他立碑，他只往海边又送了一船石头。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '青鸟',
                roleType: '女配角',
                billing: 3,
                intro: '西王母座下的信使，负责给精卫送口信。送着送着，自己也衔起了石子。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'temperament', value: 60 },
                    { attr: 'talent', value: 55 },
                    { attr: 'charm', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { temperament: 3, talent: 3, charm: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Fantasy, ScriptTheme.Ancient, ScriptTheme.Female],
        heat: 59,
        baseScore: 8.9,
    },
    {
        id: 'SCRIPT_117',
        name: '北壁',
        genre: 'movie',
        synopsis: 'K2北坡是全球唯一未被人类征服的八千米级山峰处女峰路线。中国女登山家祁岚选择这条路线——她的父亲三十年前在同一条路线上失踪。海拔7800米的雪壁上，她发现了一枚父亲当年留下的路标，指向一条从未被记录过的裂缝。风暴窗口逼近，下撤还是继续，摆在她面前。',
        roles: [
            {
                name: '祁岚',
                roleType: '女主角',
                billing: 1,
                intro: '中国登山运动员，登顶过两座八千米级山峰。这次她选的是父亲三十年前失踪的路线，在八千米以上，她的每一个判断都在替父亲走完他没走完的路。',
                level: 9,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 100 },
                    { attr: 'stamina', value: 90 },
                    { attr: 'temperament', value: 80 },
                    { attr: 'charm', value: 70 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 5, stamina: 4, temperament: 4, charm: 3 },
            },
            {
                name: '陆征',
                roleType: '男主角',
                billing: 2,
                intro: '高山摄影师，负责记录祁岚的攀登全程。他在海拔7200米的营地发现了她父亲的路标，这个发现成了她继续攀登的转折。',
                level: 8,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'stamina', value: 55 },
                ],
                shootWeeks: 4,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, stamina: 3 },
            },
            {
                name: '卓玛',
                roleType: '女配角',
                billing: 3,
                intro: '大本营的藏女队医，多吉的侄女。祁岚出发前，她把父亲留下的那枚旧路标拓片塞进了她的冲锋衣内袋。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'stamina', value: 60 },
                    { attr: 'talent', value: 55 },
                    { attr: 'temperament', value: 50 },
                    { attr: 'wisdom', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { stamina: 3, talent: 3, temperament: 2, wisdom: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Disaster, ScriptTheme.Action, ScriptTheme.SeriousDrama],
        heat: 52,
        baseScore: 8.9,
    },
    {
        id: 'SCRIPT_118',
        name: '青绿',
        genre: 'movie',
        synopsis: '敦煌研究院最年轻的壁画修复师沈药被派往莫高窟第45窟，修复一幅剥落严重的唐代经变画。她在清理底层时，发现壁画之下还藏着一幅被覆盖的北魏壁画，画中供养人的面容与自己惊人相似。修复的过程，变成了一场跨越千年的对话——她修复的不仅是壁画，还有被时间覆盖的真相。',
        roles: [
            {
                name: '沈药',
                roleType: '女主角',
                billing: 1,
                intro: '敦煌研究院壁画修复师，专攻唐代经变画。她在莫高窟待了五年，修过十七个窟，唯独没碰过剥落最严重的45窟。',
                level: 8,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 80 },
                    { attr: 'temperament', value: 70 },
                    { attr: 'wisdom', value: 65 },
                    { attr: 'charm', value: 55 },
                ],
                shootWeeks: 5,
                attributeGrowth: { talent: 4, temperament: 3, wisdom: 3, charm: 3 },
            },
            {
                name: '阿年',
                roleType: '女配角',
                billing: 3,
                intro: '研究院实习修复师，沈药的助手。每天跟着她进窟，和泥、打底、调色，从不多问一句。',
                level: 7,
                gender: 'female',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
            {
                name: '周墨',
                roleType: '男配角',
                billing: 3,
                intro: '敦煌研究院的数字扫描技师，负责45窟的三维建模。他扫出过一段壁画底层的暗纹，暗纹的走向和沈药画中人的衣褶一模一样。',
                level: 7,
                gender: 'male',
                requirements: [
                    { attr: 'talent', value: 60 },
                    { attr: 'temperament', value: 55 },
                    { attr: 'wisdom', value: 50 },
                    { attr: 'charm', value: 40 },
                ],
                shootWeeks: 3,
                attributeGrowth: { talent: 3, temperament: 3, wisdom: 2, charm: 2 },
            },
        ],
        relatedNPCs: [],
        themes: [ScriptTheme.Culture, ScriptTheme.History, ScriptTheme.SeriousDrama],
        heat: 44,
        baseScore: 8.7,
    },
];
